export enum DiscontinueFlgEnum {
  CONTINUED = '0',
  DISCONTINUED = '1',
}

export const DiscontinueFlg = [
  { label: '終了していない', value: DiscontinueFlgEnum.CONTINUED },
  { label: '終了', value: DiscontinueFlgEnum.DISCONTINUED },
];
